// removed by extract-text-webpack-plugin
module.exports = {"component":"gP3JHgjNzgGWiOrxAtQ-S","header":"PiOV6MU1MCw_6tDdZDbZL","subHeader":"nuSlPf_7b2NyNesUQNL-N"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Account/AccessManagement/AccessManagement.css
// module id = 1478
// module chunks = 0